import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import { TrimTitleSectionTemplate } from './TrimTitleSectionTemplate';

export const TrimTitleSectionStyled = styled(TrimTitleSectionTemplate)`
    display: flex;
    flex-direction: column;
    margin-top: ${rem('15px')};

    .title {
        font-weight: bold;
        font-size: ${({ theme }) => theme.fontSizes.h4};
        margin-bottom: ${rem('30px')};
    }

    .trimBenefitsContainer {
        display: none;
        margin-bottom: 45px;

        .benefits {
            margin-top: unset;
        }

        @media (max-width: ${breakpoints.sm}px) {
            display: initial;
        }
    }

    .subTitle {
        font-weight: bold;
        font-size: ${({ theme }) => theme.fontSizes.h5};
        margin-top: ${rem(30)};
        padding-bottom: ${rem(25)};
    }
`;
